module.exports = __webpack_public_path__ + "assets/img/sample2.385ef0be.jpg";